<template>
  <footer class="w-full flex flex-col space-y-8 text-center lg:flex-row lg:space-y-0 lg:text-left justify-between items-center bg-gray-800 text-white">
    <div class="p-4 leading-5 whitespace-normal overflow-hidden">
      This is a community list of <a class="text-blue-300 hover:text-blue-200" href="https://diabotical.com" target="_blank">Diabotical</a> Twitch streamers and their ingame avatars.<br class="hidden lg:inline" />
      The list was updated on November&nbsp;29,&nbsp;2020.
      <a class="text-blue-300 hover:text-blue-200" href="https://www.diabotical.com/streamer/create" target="_blank">Submit&nbsp;your&nbsp;avatar</a>.
    </div>
    <div class="flex items-center justify-center">
      Share:
      <span class="ya-share2 ml-1" data-services="twitter,facebook,vkontakte" data-counter="data-counter" data-size="s" />
    </div>
    <div class="flex items-center justify-center">
      Follow:
      <a class="ml-1 cursor-pointer opacity-100 hover:opacity-75" href="https://twitter.com/quakelife" target="_blank"><img class="h-5 w-5" src="../assets/twitter.png" alt=""/></a>
      <a class="ml-1 cursor-pointer opacity-100 hover:opacity-75" href="https://vk.com/quakelife" target="_blank"><img class="h-5 w-5" src="../assets/vk.png" alt="" style="margin-left: .1em;"/></a>
    </div>
    <div class="flex items-center justify-center">
      Donate:
      <a class="ml-1 cursor-pointer opacity-100 hover:opacity-75" href="https://paypal.me/danmer" target="_blank"><img class="h-5 w-5" src="../assets/paypal.png" alt=""/></a>
      <a class="ml-1 cursor-pointer opacity-100 hover:opacity-75" href="https://money.yandex.ru/to/41001698799375" target="_blank"><img class="h-5 w-5" src="../assets/yandex.png" alt="" style="margin-left: .1em;"/></a>
    </div>
    <div class="p-4">&copy; <a class="text-blue-300 hover:text-blue-200" :href="copyrightLink" target="_blank">Danmer</a>, 11.2020</div>
  </footer>
</template>

<script>
  export default {
    name: 'MainFooter',
    setup() {
      const copyrightLink = ('' + navigator.language).slice(0, 2) === 'ru' ? 'https://vk.com/quakelife' : 'https://twitter.com/quakelife'
      return {
        copyrightLink,
      }
    },
  }
</script>
